export const module = {
  info: {
    name: 'voip-testing-numbers-side-menu',
    caption: 'voip testing numbers side menu',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Testing Numbers',
    icon: 'el-icon-s-grid',
    routeName: 'module->voip-testing-numbers->panel-tabs->tab',
    routeParams: { tabName: 'upload-document'}
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-testing-numbers-side-menu->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-testing-numbers-side-menu->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
